define('formkit/behavior/tooltip.behavior',['require','exports','module','marionette','../../uikit/definitions/modules/popup'],function(require, exports, module) {
  var Mn = require('marionette');
  require('../../uikit/definitions/modules/popup')

  var TooltipBehavior = Mn.Behavior.extend({

    defaults: {

    },

    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);
      this.once('before:render', this.initializePopup, this);
    },

    initializePopup: function() {
      this.view.$el.popup(this.options);
    }

  });

  module.exports = TooltipBehavior;
});

